import { toast } from "sonner";

export interface PendingTabOptions {
  title: string;
  message: string;
  /** 로딩 화면 종류. "dsd-review"면 온보딩 캐러셀 로딩을 표시 */
  variant?: "dsd-review";
  /** 같은 origin의 원래 화면에 완료/실패를 알려야 하는 흐름에서만 사용한다. */
  preserveOpener?: boolean;
}

export const buildPendingTabUrl = ({
  title,
  message,
  variant,
}: PendingTabOptions) => {
  const url = new URL("/pending-tab", window.location.origin);
  url.searchParams.set("title", title);
  url.searchParams.set("message", message);
  if (variant) url.searchParams.set("variant", variant);
  return url.toString();
};

/**
 * 사용자 제스처 동안 앱의 pending 라우트를 새 탭으로 열어둔다.
 * 완료 후 호출부에서 `tab.location.replace(url)`로 실제 화면 URL을 주입한다.
 */
export const openPendingTab = (options: PendingTabOptions): Window | null => {
  const tab = window.open(buildPendingTabUrl(options), "_blank");
  if (tab && !options.preserveOpener) tab.opener = null;
  return tab;
};

/**
 * 준비해 둔 탭에 실제 주소를 주입한다. 탭이 없으면(팝업 차단, 사용자가 닫음) 새로 열어본다.
 *
 * `false` 면 결과를 보여줄 탭이 없다는 뜻 — 비동기 콜백의 `window.open` 은 사용자 제스처가
 * 끝난 뒤라 거의 항상 막힌다. 호출부는 같은 탭 이동 같은 탈출구를 줘야 한다(조용한 실패 금지).
 */
export const resolvePendingTab = (tab: Window | null, url: string) => {
  if (tab && !tab.closed) {
    tab.location.replace(url);
    return true;
  }
  return window.open(url, "_blank", "noopener") !== null;
};

/**
 * 새 탭이 막혀 결과를 띄울 곳이 없을 때의 탈출구 안내. 호출부는 같은 탭 이동을 넘긴다.
 * 작업은 이미 끝난 상태라 에러가 아니라 경고로 알린다.
 */
export const warnPopupBlocked = (actionLabel: string, open: () => void) => {
  toast.warning("브라우저가 새 탭을 막았습니다.", {
    action: { label: actionLabel, onClick: open },
  });
};
